import {NgModule} from '@angular/core';
import {OrderHistoryComponent} from "./order-history/order-history.component";
import {OrderHistoryDetailsComponent} from "./order-history-details/order-history-details.component";
import {OrderHistoryTrackingComponent} from "./order-history-tracking/order-history-tracking.component";
import {OrderHistoryProductComponent} from "./order-history-product-view/order-history-product.component";
import {OrderHistoryProductRowComponent} from "./order-history-product-view/order-history-product-row.component";
import {OrderHistorySummaryComponent} from "./order-history-summary/order-history-summary.component";
import {OrderPaymentModalComponent} from "./order-payment/order-payment-modal.component";
import {SharedModule} from "../../shared.module";
import {OrderHistoryRoutingModule} from './order-history-routing.module';
import {PaymentEntryModule} from "../../checkout/payment/payment-entry.module";
import {ExpandableCardModule} from "../expandable-card/expandable-card.module";

@NgModule({
    imports: [
        SharedModule,
        OrderHistoryRoutingModule,
        PaymentEntryModule,
        ExpandableCardModule
    ],
    declarations: [
        OrderHistoryComponent,
        OrderHistoryTrackingComponent,
        OrderHistoryDetailsComponent,
        OrderHistoryProductComponent,
        OrderHistoryProductRowComponent,
        OrderHistorySummaryComponent,
        OrderPaymentModalComponent
    ]
})
export class OrderHistoryModule { }
